import React, { useEffect, useState } from "react";
import axios from "axios";

const apiBase = process.env.REACT_APP_API_URL;

export default function MatchupRewardModal({ reward, onClose, token, teamId }) {
  // Hooks are always called unconditionally
  const [coins, setCoins] = useState(0);
  const [bonusPoints, setBonusPoints] = useState(0);
  const matchup = reward.matchup;
  const userResult = matchup.is_tie ? "tie" : matchup.winner_team_id === reward.team_id ? "win" : "loss";
  const isHomeYou = reward.matchup.home_team_id === teamId;
  const isAwayYou = reward.matchup.away_team_id === teamId;

  const homePoints = matchup.home_points;
  const awayPoints = matchup.away_points;

  useEffect(() => {
    if (!reward) return; // handle null inside useEffect

    const duration = 1000; // animation duration in ms
    const start = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      setCoins(Math.floor(progress * reward.coin_reward));
      setBonusPoints(Math.floor(progress * reward.bonus_points));

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [reward]);

  if (!reward) return null; // early return after hooks

  const handleClaim = async () => {
    try {
      if (!token) return;

      await axios.post(`${apiBase}/api/rewards/claim`, { reward_id: reward.id }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (err) {
      console.error("Failed to claim reward:", err.response?.data?.error || err.message);
    } finally {
      onClose();
    }
  };

  const SuperscriptNumber = ({ value, color }) => {
    if (value === null || value === undefined || value === "-") {
      return <span>-</span>;
    }

    const [intPart, decimalPart] = Number(value).toFixed(2).split(".");

    return (
      <span style={{ display: "inline-flex", alignItems: "flex-start" }}>
        <span>{intPart}</span>
        <span
          style={{
            fontSize: "16px",
            marginLeft: "6px",
            position: "relative",
            top: "6px",
            opacity: 0.9,
            color,
          }}>
          .{decimalPart}
        </span>
      </span>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
        <img src="/many-league-coins.png" alt="Many League Tokens" style={{ position: "absolute", top: "-60px", height: "120px" }} />
        <img
          src="/match-complete.jpeg"
          alt="Many League Tokens"
          style={{
            position: "absolute",
            left: "0",
            top: "0",
            width: "100%",
            opacity: "0.1",
            height: "100%",
            objectFit: " cover",
            WebkitMaskImage: "linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)",
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskSize: "100% 100%",
            maskImage: "linear-gradient(to left, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)",
            maskRepeat: "no-repeat",
            maskSize: "100% 100%",
            zIndex: 1,
          }}
        />
        {userResult === "win" ? (
          <img src="/win.png" style={{ height: "120px", marginTop: "40px" }} alt="Win" />
        ) : userResult === "loss" ? (
          <img src="/loss.png" style={{ height: "120px", marginTop: "40px" }} alt="Loss" />
        ) : (
          <p>TIE</p>
        )}
        <h2 style={{ letterSpacing: "-0.4px", margin: "0", opacity: "0.6", marginBottom: "10px", fontStyle: "italic" }}>
          WEEK {reward?.matchup.matchweek}
        </h2>
        <div className="matchup-display" style={{ display: "flex", flexDirection: "row", gap: 8, alignItems: "center" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 0",
              gap: 8,
            }}>
            <p>{isHomeYou && <span style={{ color: "#ffd166" }}>(You)</span>}</p>
            <h2 className="matchup-versus-total">
              <SuperscriptNumber value={homePoints} color="white" />
            </h2>
          </div>
          <div className="pts-divider">
            <img src="/vs-vector.png" style={{ opacity: "0.2", height: "24px" }} alt="VS" />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 0",
              gap: 8,
            }}>
            <h2 className="matchup-versus-total">
              <SuperscriptNumber value={awayPoints} color="white" />
            </h2>
            <p>{isAwayYou && <span style={{ color: "#ffd166" }}>(You)</span>}</p>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
          <div style={{ display: "flex", alignItems: " center", gap: 30, justifyContent: "space-between" }} className="player-price-box">
            <h4 style={{ fontSize: "15px" }}>Match result reward</h4>
            <p
              style={{
                display: "flex",
                alignItems: " center",
                gap: 4,
                color: "#32f367",
                fontWeight: 600,
                minWidth: "106px",
                justifyContent: "flex-end",
              }}>
              <img src="/league-coin.png" alt="League Coin" style={{ height: "22px", width: "22px", border: "none", objectFit: "contain" }} />+
              {(coins - bonusPoints).toLocaleString()}
            </p>
          </div>
          <div
            style={{ display: "flex", alignItems: " center", gap: 30, justifyContent: "space-between", marginTop: 10 }}
            className="player-price-box">
            <h4 style={{ fontSize: "15px" }}>Bonus for point difference</h4>
            <p
              style={{
                display: "flex",
                alignItems: " center",
                gap: 4,
                color: "#32f367",
                fontWeight: 600,
                minWidth: "106px",
                justifyContent: "flex-end",
                zIndex: 999,
              }}>
              <img
                src="/league-coin.png"
                alt="League Coin"
                style={{ height: "22px", width: "22px", border: "none", objectFit: "contain", zIndex: 999 }}
              />
              +{bonusPoints}
            </p>
          </div>
          <div
            style={{
              color: "#32f367",
              display: "flex",
              gap: 10,
              fontWeight: 600,
              justifyContent: "space-between",
              padding: "0 20px",
              zIndex: 999,
              marginTop: "20px",
            }}>
            <h4 style={{ fontSize: "15px", color: "white" }}>TOTAL:</h4>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <img
                src="/league-coin.png"
                alt="League Coin"
                style={{ height: "22px", width: "22px", border: "none", objectFit: "contain", zIndex: 999 }}
              />
              +{coins.toLocaleString()}
            </span>
          </div>
          <div
            style={{
              color: "  white",
              display: "flex",
              gap: 10,
              fontWeight: 600,
              margin: 0,
              justifyContent: "space-between",
              padding: "0 20px",
              zIndex: 999,
            }}>
            <h4 style={{ fontSize: "15px", color: "white" }}>REP:</h4> +200XP
          </div>
        </div>
        <button onClick={handleClaim} className="edit-btn" style={{ zIndex: 999, marginTop: 40, width: "100%" }}>
          Claim
        </button>
      </div>
    </div>
  );
}
